import { render, staticRenderFns } from "./SexTooltip.vue?vue&type=template&id=0b200eea&scoped=true&"
import script from "./SexTooltip.vue?vue&type=script&lang=js&"
export * from "./SexTooltip.vue?vue&type=script&lang=js&"
import style0 from "./SexTooltip.vue?vue&type=style&index=0&id=0b200eea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/.registry.npmjs.org/vue-loader/15.9.8_css-loader@3.6.0+webpack@4.46.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b200eea",
  null
  
)

export default component.exports